import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteGiveawayItem = async (id) => {
  const { data } = await SigliveServiceV1({
    method: 'DELETE',
    url: `/briefs/giveaways/${id}`,
  });

  return data?.data;
};

export default deleteGiveawayItem;
